import { Route } from "@angular/router";
import { CasierComponent } from "./casier.component";

export const CasierRouting: Route = {
  path: "casier",
  component: CasierComponent,
  data: {
    breadcrumb: "Casier"
  }
};
